import store from 'utils/store/withMiddleware'
import { getVariant } from 'core/experiment'
import {
  PPI_1142_FLEX_BENEFIT,
  PPI_1142_FLEX_BENEFIT_VARIANTS
} from 'core/constants/experiments'
import { propAccessor } from '@hc-frontend/utils'
import storage from 'proxy-storage'

// Temporal fix to solve amplitude block issue
const defaultStates = 'al-az-ar-de-fl-ga-ia-ky-ms-ne-nd-nv-ok-sc-tn-tx-wv-wi-wy'

export function enableFlexBenefits(): boolean {
  const variant = getVariant({
    experimentKey: PPI_1142_FLEX_BENEFIT,
    fallback: PPI_1142_FLEX_BENEFIT_VARIANTS.ON
  })
  
  // If the variant is ON, we disable flex benefits
  if (variant === PPI_1142_FLEX_BENEFIT_VARIANTS.ON) {
    return false
  }

  // Check if the state acronym is in the variant, so we can enable flex benefits for specific states
  if (variant !== PPI_1142_FLEX_BENEFIT_VARIANTS.OFF) {
    const stateAcronym =
      propAccessor(storage.getItem('hc'), 'location.state_acronym') ||
      propAccessor(store.getState(), 'hcStorage.location.state_acronym')
    if (stateAcronym && variant) {
      const active = variant.split('-').includes(stateAcronym.toLowerCase())
      return active
    }
  }

  // By default, we don't enable flex benefits
  return false
}
